/* eslint-disable */
/**
 * [defaultParams description]
 * @type {Object}
 */

import { getLanguage } from '../../utils/index.js'

import { Loading, MessageBox } from 'element-ui'

import Axios from 'axios'
const message = {
  lang: 'zh-CN',
  payload: {
    params: {}
  }
}

let mergeParams = params => {
  let copyMessage = JSON.parse(JSON.stringify(message))
  copyMessage.lang = getLanguage()
  let role = sessionStorage.getItem('role')
  if (!role === '"enterpriseadmin"') {
  }
  let companyId =
    role === '"enterpriseadmin"'
      ? sessionStorage.getItem('companyId')
      : undefined
  if (params !== undefined && params.ext) {
    let ext = params.ext
    let keys = Object.keys(ext)
    keys.forEach(key => {
      copyMessage.payload[key] = ext[key]
    })
  }
  if (params !== undefined && params.params && params.pager) {
    copyMessage.payload = params.pager
    copyMessage.payload.params = params.params
  } else {
    copyMessage.payload.params = params || {}
  }
  if (!copyMessage.payload.params.companyId && companyId) {
    copyMessage.payload.params.companyId = companyId
  }
  return copyMessage
}

let submit = (
  options = {
    params: {},
    method: 'POST',
    action: '',
    target: '_blank'
  }
) => {
  var form = document.createElement('form')
  form.method = options.method
  form.action = options.action
  form.target = options.target
  form.style.display = 'none'
  for (let param in options.params) {
    var element = document.createElement('input')
    element.name = param
    element.value = options.params[param]
    form.appendChild(element)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Axios.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest'
Axios.defaults.withCredentials = true
let service = Axios.create({
  baseURL: '/', // api的base_url
  timeout: 50000 // 请求超时时间
})

// request拦截器 axios的一些配置
service.interceptors.request.use(
  config => {
    config.headers['lang'] = getLanguage()
    return config
  },
  error => {
    // Do something with request error
    console.error('error:', error) // for debug
    Promise.reject(error)
  }
)

// service.interceptors.response.use(
//   response=>{
//     return response
//   }
// )

let $fetch = Vue => {
  let fetch = {}
  fetch.unLogin = () => {
    window.location.href = '/'
  }
  fetch.unAuth = message => {
    let $vue = new Vue()
    $vue.$notify.close()
    $vue.$notify.warning({
      title: window.vm.$t('common.warningNotice'),
      message: message
    })
  }
  ;['get', 'delete', 'head', 'jsonp'].forEach(method => {
    fetch[method] = function(url, options) {
      return new Promise((resolve, reject) => {
        service[method](url, options)
          .then(data => {
            if (data.data.code === '300' || data.data.code === 'E0010000') {
              fetch.unLogin()
            }
            resolve(data.data)
          })
          .catch(data => {
            console.log('get', data)
            if (data.response.status === '504') {
              fetch.unLogin()
            }
            try {
              if (data.response.data.code === 'E0010000') {
                fetch.unLogin()
              } else {
                reject(data)
              }
            } catch (error) {
              reject(data)
            }
          })
      })
    }
  })
  ;['post', 'put', 'patch'].forEach(method => {
    fetch[method] = function(url, body, options, showLoad, message) {
      let loadingInstance = null
      if (showLoad) {
        loadingInstance = Loading.service({
          lock: true,
          fullscreen: true,
          text: message || 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      return new Promise((resolve, reject) => {
        service[method](url, mergeParams(body), options)
          .then(data => {
            if (loadingInstance) {
              loadingInstance.close()
            }
            if (data.data.code == '300' || data.data.code === 'E0010000') {
              fetch.unLogin()
            }
            if (data.data.code == '400') {
              fetch.unAuth(data.data.message)
              return
            }
            resolve(data.data)
          })
          .catch(data => {
            if (loadingInstance) {
              loadingInstance.close()
            }
            // if (data.response.status == '404') {
            //   fetch.unLogin()
            // }
            try {
              if (
                data.response.data.code === 'E0010000' ||
                data.response.data.code === '300'
              ) {
                fetch.unLogin()
              } else {
                reject(data)
              }
            } catch (error) {
              reject(data)
            }
          })
      })
    }
  })
  fetch.submit = submit

  return fetch
}

let plugin = Vue => {
  Vue.fetch = $fetch(Vue)
  Vue.prototype.$fetch = Vue.fetch
}
export default plugin



// WEBPACK FOOTER //
// ./src/cdpBase/plugin/fetch/index.js